// slider for gallery block
const GallerySlider = ($) => {
	const experienceBreakpoints = [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1.5,
				arrows: false,
			},
		},
		{
			breakpoint: 780,
			settings: {
				slidesToShow: 1.1,
				arrows: false,
			},
		},
	];
	$(document).ready(function () {
		$("#gallery-slider").slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: '<div class="slick-prev slick-arrow"></div>',
			nextArrow: '<div class="slick-next slick-arrow"></div>',
			responsive: experienceBreakpoints,
		});
	});
};

export default GallerySlider;
